<template>
  <div class="mt-10">
    <TifDistrictsCriteria
    :baseCrudKey="baseCrudKey"
    @loadCRUDList="handleLoadTifDistrcitsList"/>
    <v-container>

<div >
<CRUDList class="mt-10"
:canAdd="true" :canEdit="true" :canSave="true"
  :showSelect="false"
  @loadCRUDList="handleLoadTifDistrcitsList"
  @upsertItem="upsertRecords"
  :headers="headers"
  :loadingData="gridLoading.flag"
  :selectedItems="selectedItems"
  :loadingText="gridLoading.text"
  :dialogHeaderName="dialogHeaderName"
  :enableFixedHeaders="true" :displayTopPagination="false"
  :baseCrudKey="baseCrudKey"
  :createNewItem="newTifDistrict"
  tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
  tableDynamicClassname='taxroll-custom-table'
  tableDynamicHeight='200'
  dialogDynamicWidth="500"
  :defaultSortBy="defaultSortBy"
  >
  <template v-slot:[`editedItem`]="{}">
        <tifDistrictsEditDialog
        :baseCrudKey="baseCrudKey"
        />
      </template>
</CRUDList>
<template>
</template>
</div>
</v-container>
  </div>

</template>
<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { tifDistrictsHeaders } from '../../shared/Utils/taxHeaders.utils';
import TifDistrictsCriteria from './TifDistrictsCriteria.vue';
import tifDistrictsEditDialog from './tifDistrictsEditDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import '../../../assets/style.css';

export default {
  name: 'TifDistrictsList',
  data() {
    return {
      baseCrudKey: 'tifDistricts',
      headers: tifDistrictsHeaders,
      gridLoading: defaultGridLoading(),
      dialogHeaderName: 'TIF District RECORD',
      isItFirstCallOrNot: false,
    };
  },
  components: {
    CRUDList,
    TifDistrictsCriteria,
    tifDistrictsEditDialog,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      StoreSelItems: (state) => state.tax.tifDistricts.selectedItems,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'distributionTaxDistrict',
          direction: 'asc',
        },
      ];
    },
  },
  mounted() {
    if (this.latestTaxYear) {
      this.criteriaState.taxYear = this.latestTaxYear;
      this.isItFirstCallOrNot = true;
      this.handleLoadTifDistrcitsList();
    }
  },
  watch: {
    latestTaxYear(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadTifDistrcitsList();
      }
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapMutations('tax/tifDistricts', [
      'setSelectedItems',
    ]),
    ...mapActions('tax/tifDistricts', [
      'loadTifDistrictsRecords',
      'upserttifDistrict',
    ]),
    // a new TIF distributes all of its overage until the % is lowered
    newTifDistrict() {
      return { overgaeToTif: 100 };
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      await this.upserttifDistrict({ item: updatedItem, baseCrudKey });
    },
    handleLoadTifDistrcitsList() {
      if (this.isItFirstCallOrNot) {
        const { baseCrudKey } = this;
        const criteria = { ...this.criteriaState };
        manageGridLoading(this, true, 'Searching...');
        this.loadTifDistrictsRecords({ baseCrudKey, criteria }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
  },

};
</script>
